/**
 * ChipFilter — horizontal pills that toggle selection.
 * Extracted from FilterBar.jsx for reuse across filter configurations.
 */

export default function ChipFilter({ options = [], value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
      {options.map((opt) => {
        const v = typeof opt === 'string' ? opt : (opt.value ?? opt.key);
        const lbl = typeof opt === 'string' ? opt : (opt.label ?? opt.name ?? v);
        const active = value === v;
        return (
          <button
            key={v}
            onClick={() => onChange(active ? '' : v)}
            style={{
              padding: '6px 14px',
              borderRadius: 9999,
              fontSize: 12,
              fontWeight: 500,
              background: active ? 'var(--accent)' : 'var(--glass)',
              color: active ? 'var(--on-navy)' : 'var(--t2)',
              border: active ? 'none' : '1px solid var(--bdr)',
              transition: 'all 150ms var(--ease)',
              whiteSpace: 'nowrap',
              minHeight: 44,
              cursor: 'pointer',
            }}
          >
            {lbl}
          </button>
        );
      })}
    </div>
  );
}
